import { render } from "./GoatGhost.vue?vue&type=template&id=4f326086"
import script from "./GoatGhost.vue?vue&type=script&lang=js"
export * from "./GoatGhost.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__